module.exports = __webpack_public_path__ + "img/app_customers_say_01.2e7bd69d.jpg";